/**
 * Created by Jason on 2017-6-21.
 */
//编辑器
import '../../assets/lib/trumbowyg/trumbowyg'
import '../../assets/lib/trumbowyg/ui/trumbowyg.css'
import '../../assets/lib/trumbowyg/plugins/upload/trumbowyg.upload'
import '../../assets/lib/trumbowyg/plugins/colors/ui/trumbowyg.colors.css'
import '../../assets/lib/trumbowyg/plugins/colors/trumbowyg.colors'

let options = {
    lang: 'zh_cn',
    removeformatPasted: true,
    btns: [
        ['undo', 'redo'],
        ['formatting', 'strong', 'em', 'underline', 'foreColor', 'backColor', 'removeformat'],
        ['justifyLeft', 'justifyCenter', 'justifyRight'],
        ['upload'],
        'btnGrp-lists'
    ],
    plugins: {
        upload: {
            serverPath: SERVER + '/transmit/uploadTopicTextAreaImage',
            fileFieldName: 'img',
            urlPropertyName: function (json) {
                return SERVER + '/upload/editor/' + json.data.img
            },

            statusPropertyName: function (json) {
                return json.status == 0
            }
        }
    }
}

class Editor {

    constructor ($el) {
        this.editor = $el.trumbowyg(options);
        this.pasteInit($el)
    }

    pasteInit ($el) {

        // >IE11 Chrome Firefox
        $el.on('paste', function (e) {

            let items = window.clipboardData ? window.clipboardData.files : e.originalEvent.clipboardData.items;
            if (!items || !items.length) {
                return;
            }
            let i = 0
            let len = items.length
            let upload = options.plugins.upload
            let formData = new FormData()
            let has = false
            for (; i < len; i++) {
                let file;
                if (window.clipboardData) {
                    let file = items[i]
                    formData.append(upload.fileFieldName, file)
                    has = true
                    break
                } else if (items[i].kind === 'file') {
                    formData.append(upload.fileFieldName, items[i].getAsFile())
                    has = true
                    break
                }
            }
            if (!has) {
                return;
            }
            setTimeout(function () {
                $.ajax({
                    type: 'POST',
                    url: upload.serverPath,
                    data: formData,
                    processData: false,
                    contentType: false,
                    success(json) {
                        if (upload.statusPropertyName(json)) {
                            let trumbowyg = $el.data('trumbowyg')
                            let url = upload.urlPropertyName(json)
                            trumbowyg.doc.execCommand('insertImage', false, url)
                        }
                    }
                })
            }, 0)

        })
    }
}

module.exports = Editor


// WEBPACK FOOTER //
// ./src/assets/js/editor.js